import AvailabilityGlance from '@/components/Availability/AvailabilityGlance';
import { F } from '@/utils/intl';
import { Popover, Space, Tag } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';
import React, { useMemo } from 'react';


export default function OpenHoursOverview({openingHours}) {
  const activeDaysCount = useMemo(() => {
    if (!openingHours) return 0;
    if (Array.isArray(openingHours)) {
      return new Set(openingHours.map((oh) => oh.day)).size;
    }
    return Object.keys(openingHours).length;
  }, [openingHours]);

  const hasOpeningHours = activeDaysCount > 0;

  return (
    <Popover
      arrow={false}
      content={
        hasOpeningHours ? (
          <AvailabilityGlance availability={openingHours} />
        ) : (
          <F
            id={'pages.locations.noOpeningHours'}
            defaultMessage={'No opening hours set.'}
          />
        )
      }
    >
      <Tag
        bordered={false}
        style={{ marginRight: 0 }}
        color={hasOpeningHours ? 'default' : 'red'}
      >
        <Space size={2}>
          <ClockCircleOutlined />
          <span>{activeDaysCount}</span>
        </Space>
      </Tag>
    </Popover>
  );
}
